<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryFormRef"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="分享链接" prop="shareUrl">
        <el-input
          v-model="queryParams.shareUrl"
          placeholder="请输入分享链接"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          style="width: 240px"
          v-model="queryParams.status"
          placeholder="请选择状态"
          @change="handleQuery"
          clearable
        >
          <dictionary-option code="commonStatus" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="Refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      v-loading="loading"
      :data="dataList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="分享编号" align="center" prop="id" width="180" />
      <el-table-column label="分享链接" prop="shareUrl">
        <template #default="{ row }">
          <router-link :to="'/share/' + row.shareUrl" target="_blank"
            >{{ getHost() }}/share/{{ row.shareUrl }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column label="分享用户" :show-overflow-tooltip="true">
        <template #default="{ row }"
          >{{ row.nickName }}({{ row.username }})</template
        >
      </el-table-column>
      <el-table-column
        label="分享密码"
        prop="sharePassword"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="访问次数"
        prop="visitCount"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="创建时间" align="center" width="160">
        <template #default="{ row }">
          <span>{{ parseTime(row.gmtCreate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="显示用户信息"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="{ row }">
          <dictionary-tag code="yesNo" :value="row.showUserInfo" />
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="{ row }">
          <dictionary-tag code="commonStatus" :value="row.status" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="160"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            icon="Edit"
            @click="handleUpdate(row)"
            v-permission="['nav:share:update']"
            >修改</el-button
          >
          <el-button
            type="text"
            icon="Delete"
            @click="handleDelete(row)"
            v-permission="['nav:share:delete']"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="totalCount > 0"
      :total="totalCount"
      v-model:page="queryParams.pageNum"
      v-model:limit="queryParams.pageSize"
      @pagination="getPage"
    />

    <!-- 新增和编辑 -->
    <edit @fetch-data="handleQuery" ref="editRef"></edit>
  </div>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'
import Edit from './components/ShareEdit'

import { page, remove } from '@/api/nav/share'

const { proxy } = getCurrentInstance()

const loading = ref(true)
const dataList = ref([])
const totalCount = ref(0)

const queryParams = ref({
  pageNum: 1,
  pageSize: 10,
  shareUrl: undefined,
  status: undefined,
  orderColumn: 'gmtCreate,id',
  orderType: 'desc,desc'
})

/**
 * 获取数据
 */
async function getPage() {
  loading.value = true
  const {
    data: { total, list }
  } = await page(queryParams.value)
  totalCount.value = parseInt(total)
  dataList.value = list
  loading.value = false
}

/**
 * 搜索
 */
function handleQuery() {
  getPage()
}

/**
 * 重置
 */
function handleResetQuery() {
  proxy.resetForm('queryFormRef')
  handleQuery()
}

/**
 * 修改
 */
function handleUpdate(row) {
  proxy.$refs.editRef.show(row.id)
}

/**
 * 删除按钮操作
 */
async function handleDelete(row) {
  const deleteIds = row.id
  proxy.$modal
    .confirm('是否确认删除分享编号为【' + deleteIds + '】的数据项?')
    .then(async function () {
      await remove(deleteIds)
      proxy.$modal.msgSuccess('删除分享成功')
      handleQuery()
    })
}

/**
 * 初始化
 */
getPage()
</script>
